export const SNACKBAR = "SNACKBAR";
export const SNACKBAR_GLOBAL_NOTIFICATIONS = "SNACKBAR_GLOBAL_NOTIFICATIONS";
export const SNACKBAR_CLOSE = "SNACKBAR_CLOSE";
export const SNACKBAR_RESOLVE_GLOBAL_NOTIFICATION =
  "SNACKBAR_RESOLVE_GLOBAL_NOTIFICATION";
export const SNACKBAR_CLOSE_ALL = "SNACKBAR_CLOSE_ALL";
